import React, { useEffect } from 'react';

import {
    CppCoachActions,
    CppCoachSurfaces,
    CppPlayerActions,
} from '../../Analytics/constants';
import useCPPTracking from '../../hooks/useCPPTracking';
import useCppDiscoveryBanner from './useCppDiscoveryBanner';
import styles from './cppDiscoveryBanner.scss';

const TESTID_PREFIX = 'cpp.discovery-banner';

const COPY = {
    junior: {
        headline: 'New for College Prospects!',
        subhead: 'Take control of your college recruiting journey.',
        cta: 'Go to my profile',
    },
    coach: {
        headline: 'New for College Coaches!',
        subhead: 'Manage your recruits from the College Prospects tab in your college profile.',
        cta: 'Go to my college',
    },
};

const CppDiscoveryBanner = () => {
    const { variant, onCtaClick, placement } = useCppDiscoveryBanner();
    const { trackPlayerEngagement, trackCoachEngagement } = useCPPTracking();

    useEffect(() => {
        if (variant === 'junior') {
            trackPlayerEngagement(CppPlayerActions.CPP_DISCOVERY_BANNER_VIEWED, { placement });
        } else if (variant === 'coach') {
            trackCoachEngagement(
                CppCoachActions.CPP_COACH_DISCOVERY_BANNER_VIEWED,
                CppCoachSurfaces.DISCOVERY_BANNER,
            );
        }
    // trackPlayerEngagement / trackCoachEngagement are re-created every render; keying
    // impression firing to variant + placement keeps this to one event per render pass
    // where the banner actually appears.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [variant, placement]);

    if (!variant) {
        return null;
    }

    const copy = COPY[variant];
    return (
        <button
            type="button"
            className={styles.banner}
            onClick={onCtaClick}
            data-testid={`${TESTID_PREFIX}.container`}
            data-variant={variant}
        >
            <span className={styles.text} data-testid={`${TESTID_PREFIX}.text`}>
                <span className={styles.headline} data-testid={`${TESTID_PREFIX}.headline`}>
                    {copy.headline}
                </span>
                {' '}
                <span className={styles.subhead} data-testid={`${TESTID_PREFIX}.subhead`}>
                    {copy.subhead}
                </span>
            </span>
            <span
                className={styles.cta}
                data-testid={`${TESTID_PREFIX}.cta`}
                aria-hidden="true"
            >
                {copy.cta}
            </span>
        </button>
    );
};

export default CppDiscoveryBanner;
